import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment/min/moment-with-locales';
import Moment from 'react-moment';
import useCompanyStore from './stores/companyStore';
import useConfigStore from './stores/configStore';
import useUsersStore from './stores/usersStore';

// App Routes
import Routes from './Routes';

// Vendor dependencies
import './Vendor';
// Application Styles
import './styles/bootstrap.scss';
import './styles/app.scss';

// Configure Moment.js globally
Moment.globalMoment = moment;
Moment.globalLocale = 'fr';
Moment.globalFormat = 'D MMM YYYY';
Moment.globalTimezone = 'America/Los_Angeles';
Moment.globalLocal = true;
Moment.globalElement = 'span';
Moment.globalFilter = (d) => d.toUpperCase();

const App = () => {
  const setGApi = useConfigStore((state) => state.setGApi);
  const fetchCompany = useCompanyStore((state) => state.fetchCompany);
  const fetchUsers = useUsersStore((state) => state.fetchUsers);

  useEffect(() => {
    // Initialize API key
    setGApi(process.env.REACT_APP_GOOGLE_API_KEY);
  }, [setGApi]);

  useEffect(() => {
    const fullUrl = window.location.href;
    if (fullUrl.includes('applicationCreation') || fullUrl.includes('login') || fullUrl.includes('register')) {
      return;
    }

    fetchCompany().catch((error) => {
      console.error('Failed to initialize company data:', error);
    });

    fetchUsers().catch((error) => {
      console.error('Failed to initialize users data:', error);
    });
  }, []);

  const basename = '.';

  return (
    <>
      <BrowserRouter basename={basename}>
        <Routes />
      </BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default App;
